/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import {
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import sidebarActions from 'loraactions/sidebar';
import styles from './styles.scss';
import imgLeft from './images/collapse-left.svg';
import imgRight from './images/collapse-right.svg';


const defaultProps = {
  height: null,
};

const propTypes = {
  collapsed: React.PropTypes.bool.isRequired,
  height: React.PropTypes.number,
  title: React.PropTypes.any.isRequired,
  menuItems: React.PropTypes.any.isRequired,
  toggleSidebar: React.PropTypes.func.isRequired,
};

class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { collapsed } = nextProps;
    if (collapsed !== this.props.collapsed) {
      this.setState({ collapsed });
    }
  }

  render() {
    const { collapsed } = this.state;
    const { height, title, menuItems, toggleSidebar } = this.props;

    const menuNodes = menuItems
      .filter(mi => !_.has(mi, 'show') || mi.show)
      .map((mi) => {
        const menuNode = (
          <Link onClick={mi.onClick} key={mi.text}>
            <div styleName={`menu-item ${mi.active ? ' active' : ''} ${mi.beta ? ' beta' : ''}`}>
              <div styleName="menu-icon">{mi.icon}</div>
              <div styleName="menu-text">{mi.text}</div>
            </div>
          </Link>
        );
        if (collapsed) {
          const tooltip = (
            <Tooltip id={mi.text}>{mi.text}</Tooltip>
          );
          return (
            <OverlayTrigger key={mi.text} placement="right" overlay={tooltip}>
              {menuNode}
            </OverlayTrigger>
          );
        }
        return menuNode;
      });

    return (
      <div
        styleName={`sidebar ${collapsed ? 'collapsed' : ''}`}
        style={{ height }}
        ref={(ref) => { this.sidebarRef = ref; }}
      >
        <Link onClick={toggleSidebar} href="#">
          <div styleName="toggle">
            <div styleName="title">
              {title}
            </div>
            <div styleName="arrow">
              {collapsed
                ? <img src={imgRight} alt=">" />
                : <img src={imgLeft} alt="<" />
              }
            </div>
          </div>
        </Link>
        <div styleName="menu">
          {menuNodes}
        </div>
      </div>
    );
  }
}

SideBar.defaultProps = defaultProps;
SideBar.propTypes = propTypes;

export default connect(
  state => ({
    collapsed: state.sidebar.collapsed,
  }),
  {
    pushState: routerActions.push,
    toggleSidebar: sidebarActions.toggleSidebar,
  },
)(CSSModules(SideBar, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/components/SideBar/index.jsx